<template>
  <smd-one-col-layout class="m-root-pharmacy-orders"
                      content-styles="full-width">
    <smd-header slot="header" nav>
      <span class="ns-icon-ico027"
            slot="left-actions"
            @click="goBack"/>
      <text-string label-id="txt070"/>
      <span class="ns-icon-ico001"
            slot="right-actions">
        <span class="path1"></span>
        <span class="path2"></span>
      </span>
    </smd-header>
    <div class="m-root-pharmacy-orders__step"
         slot="toolbar">
      <smd-step-progress :options="computedSteps"
                         :current-step="activeStep"/>
    </div>

    <component :is="activeComponent"
               @set-active-step="setActiveStep"/>
  </smd-one-col-layout>
</template>

<script>
  import RootPharmacyOrdersMixin from "@/views/pharmacy-orders/root-pharmacy-orders-mixin";

  export default {
    name: "m-root-pharmacy-orders-new",
    mixins: [RootPharmacyOrdersMixin]
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .m-root-pharmacy-orders__step {
    margin-top: space(s);
    height: 55px;

    .smd-step-progress {
      width: 90%;
      max-width: 600px;
      margin: 0 auto;
    }
  }
</style>